import "../styles/login.css";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function Login() {
	const { login } = useAuth();
	const [username, setUsername] = useState("");
	const [password, setPassword] = useState("");
	const [error, setError] = useState(null);
	const [loading, setLoading] = useState(false);
	const navigate = useNavigate();

	const onSubmit = async (e) => {
		e.preventDefault();
		setError(null);
		setLoading(true);
		try {
			const res = await fetch("/admin/login", {
				method: "POST",
				headers: { "Content-Type": "application/json" },
				body: JSON.stringify({ username, password })
			});
			const data = await res.json();
			if (!res.ok) throw new Error(data.error || "Login failed");
			login(data.token, data.user);
			navigate("/registrations");
		} catch (err) {
			setError(err.message);
		} finally {
			setLoading(false);
		}
	};

	return (
		<div className="login-page page-container">
			<h2>Admin Login</h2>
			<form onSubmit={onSubmit} className="login-form-container">
				<div className="input-wrapper">
					<label className="field-label-block">Username</label>
					<input value={username} onChange={(e) => setUsername(e.target.value)} required />
				</div>
				<div className="input-wrapper">
					<label className="field-label-block">Password</label>
					<input
						type="password"
						value={password}
						onChange={(e) => setPassword(e.target.value)}
						required
					/>
				</div>
				<button disabled={loading} className="login-button" type="submit">
					{loading ? "Logging in..." : "Login"}
				</button>
				{error && <p className="status-error">{error}</p>}
			</form>
		</div>
	);
}
